import axios from 'axios';

export default {
    methods: {
        async empresaDepositos(empresa_id, ok, err) {
            try {
                let r = await axios.post('empresa/depositos', {empresa_id: empresa_id})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async empresaSelect(ok, err) {
            try {
                let r = await axios.post('empresa/select');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/empresa.js